import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbModal, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '@digital-platform/rs-auth/domain';
// TODO: Fix this import warning about module boundaries
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { AccountDropdownBoxComponent } from '@digital-platform/rs-auth/feature-auth';
import { IdentityService } from '@digital-platform/rs-auth/services';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@UntilDestroy()
@Component({
  selector: 'digital-platform-mobile-nav-toggle',
  templateUrl: './mobile-nav-toggle.component.html',
  styleUrls: ['./mobile-nav-toggle.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    NgbPopoverModule,
    AccountDropdownBoxComponent,
    RouterLink,
  ],
})
export class MobileNavToggleComponent {
  @Input() mobileNavOpen = false;
  @Output() toggle = new EventEmitter<void>();

  private identityService = inject(IdentityService);

  public userName$: Observable<string | undefined> =
    this.identityService.user$.pipe(map((user: User) => user.profile?.name));
  public isLoggedIn = false;

  private readonly router = inject(Router);
  public accountDropdownOpened = false;

  constructor(private modalService: NgbModal) {
    this.userName$.subscribe((userName) => {
      this.isLoggedIn = !!userName;
    });
  }

  openMenuOrNavigate() {
    if (this.isLoggedIn) {
      // Open the modal in fullscreen until `xl` (1200px) breakpoint
      this.accountDropdownOpened = true;
      const modalRef = this.modalService.open(AccountDropdownBoxComponent, {
        fullscreen: 'xl',
      });
      modalRef.dismissed.subscribe(() => {
        this.accountDropdownOpened = false;
      });
      modalRef.componentInstance.styles = {
        padding: '32px',
        'background-color': '#F6F6F6',
      };
      modalRef.componentInstance.isMobile = true;
    } else {
      this.router.navigateByUrl('/account/login');
    }
  }

  onToggle(): void {
    this.toggle.emit();
  }
}
